// Lee los ids de módulos del borrador.
export function userModuleIds(data: any) {
    if (data) return idsOf(data.modules);
    return [];
}

// Lee los ids de una lista.
export function idsOf(modules: any) {
    if (modules) return collectIds(modules);
    return [];
}

// Recolecta ids de módulos.
export function collectIds(modules: any[]) {
    const ids: string[] = [];
    for (const module of modules) ids.push(module.id);
    return ids;
}

// Habilitado por defecto salvo apagado explícito.
function enabledOrDefault(form: any): boolean {
    return form.enabled ?? true;
}

// Arma el payload del usuario.
export function userPayload(form: any, modules: string[]) {
    return { ...form, enabled: enabledOrDefault(form), moduleIds: modules };
}
